import { render, staticRenderFns } from "./SedativeInputGroup.vue?vue&type=template&id=00c5a372"
import script from "./SedativeInputGroup.vue?vue&type=script&lang=js"
export * from "./SedativeInputGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports